<template>
  <v-container
    id="maingallery"
    class="pt-12 pb-0 px-0"
    fluid
    tag="section"
  >
    <headline :gallery="gallery" />

    <gallery :path="path" />
  </v-container>
</template>

<script>
  export default {
    name: 'MainGallery',
    components: {
      Gallery: () => import('@/components/Gallery'),
      Headline: () => import('./components/Headline'),
    },
    props: { path: String },
    data: () => ({
      gallery: {
        type: Object,
        default: () => ({
          category: undefined,
          date: undefined,
          blurb: undefined,
          src: undefined,
          banner: undefined,
          title: undefined,
        }),
      },
    }),
    created () {
      this.getGallery()
    },
    methods: {
      getGallery () {
        this.$http.get(this.$config.api + '/gallery/' + this.path).then(response => {
          return response.json()
        }).then(jsonData => {
          this.gallery = jsonData
        })
      },
    },
  }
</script>
